import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetVacancyList = {
  getVacancyList: { data: null, loading: false, error: null },
};

export const getVacancyList = createAsyncThunk('user/getVacancyList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/vacancies/`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetVacancyList = {
  [getVacancyList.pending]: (state) => {
    state.getVacancyList.data = null;
    state.getVacancyList.loading = true;
    state.getVacancyList.error = null;
  },
  [getVacancyList.fulfilled]: (state, action) => {
    state.getVacancyList.loading = false;
    state.getVacancyList.data = action.payload;
    state.getVacancyList.error = null;
  },
  [getVacancyList.rejected]: (state, action) => {
    state.getVacancyList.loading = false;
    state.getVacancyList.error = action.payload;
  },
};
